// extracted by mini-css-extract-plugin
module.exports = {"tags":"Jf6BT","tag":"_3hkuy","content":"VyKSb"};